<template>
    <div>
        <template v-if="loadingLesson">
            <div class="preloader" style="display: flex;flex-direction: column;">
                <img src="/assets/images/logo.svg"/>
                <h2 class="text-white">
                    Integrated Platform
                </h2>

                <div class="sk-double-bounce">
                    <div class="sk-child sk-double-bounce1"></div>
                    <div class="sk-child sk-double-bounce2"></div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="mdk-header-layout__content page-content ">

                <div class="navbar navbar-list bg-white navbar-light navbar-expand-sm" style="white-space: nowrap;">
                    <div class="container flex-column flex-sm-row">
                        <nav class="nav navbar-nav navbar-list__item no-bottom_border">
                            <div class="nav-item">
                                <div class="media flex-nowrap">
                                    <template v-if="courseLoaded">
                                        <div class="media-left mr-16pt">
                                            <a ><img :src="courseData.avatar" width="40"
                                                                                    alt="Course avatar" class="rounded"></a>
                                        </div>
                                        <div class="media-body">
                                            <span class="card-title text-body mb-0">{{courseData.title}}</span>
                                            <p class="lh-1 d-flex align-items-center">

                                            </p>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </nav>
                        <ul class="no-bottom_border navbar-list__item nav navbar-nav ml-sm-auto align-items-center align-items-sm-end">

                            <li class="nav-item">
                                <router-link class="btn btn-accent text-white" :to="{ name: 'course-detail', params: {
														id: this.$route.params.onlineClassId
														}}">Go back to Course lessons </router-link>
                            </li>

                            <li class="nav-item">
                                <a href="#discussion"  class="btn btn-accent">Discussions</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="bg-gradient-primary pb-lg-64pt py-32pt">

                    <template v-if="lessonLoaded">
                        <div class="container">
                            <nav v-if="activeModule && module.length >= 1"  class="course-nav">

                                <a
                                        :disabled="Number(this.$route.params.id) === this.getLessonIds[0]"
                                        v-if="Number(this.activeModuleIndex[0][0]) === 0"
                                        @click="prevLesson"
                                        class="tool" data-tip="Previous module"
                                ><span class="material-icons ">chevron_left</span>
                                    <div style="
                                                top: 37px;
                                                display: inline;
                                                position: absolute;
                                                text-align: center;
                                                color:#fff;

                                            ">
                                        Previous
                                    </div>
                                </a>

                                <a
                                        v-else
                                        :disabled="Number(this.activeModuleIndex[0][1]) === this.moduleIds[0][0]"
                                        @click="prev"
                                        class="tool" data-tip="Previous module"
                                ><span class="material-icons ">chevron_left</span>
                                    <div style="
                                                top: 37px;
                                                display: inline;
                                                position: absolute;
                                                text-align: center;
                                                color:#fff;

                                            ">
                                        Previous
                                    </div>
                                </a>

                                <template v-if="lessons.modules && lessons.modules.length">
                                    <ModuleItem
                                            v-for="module in lessons.modules"
                                            :key="module.id"
                                            :module="module"
                                            :activeId="activeModule"
                                            @click.native="setActiveModule(module.id)"/>
                                </template>

                                <a class="tool" data-tip="Next module"

                                   :disabled="Number(this.$route.params.id) === this.getLessonIds[this.getLessonIds.length - 1]"
                                   v-if="Number(this.activeModuleIndex[0][0]) + 1 === this.moduleIds.length"
                                   @click="nextLesson"
                                >
                                    <span class="material-icons">chevron_right</span>
                                    <div style="
                                                top: 37px;
                                                display: inline;
                                                position: absolute;
                                                text-align: center;
                                                color:#fff;
                                            ">
                                        Next
                                    </div>
                                </a>
                                <a class="tool" data-tip="Next module"

                                   v-else
                                   :disabled="Number(this.activeModuleIndex[0][0]) + 1 >= this.moduleIds.length"
                                   @click="next"
                                >
                                    <span class="material-icons">chevron_right</span>
                                    <div style="
                                                top: 37px;
                                                display: inline;
                                                position: absolute;
                                                text-align: center;
                                                color:#fff;
                                            ">
                                        Next
                                    </div>
                                </a>
                            </nav>

                        </div>
                    </template>
                </div>
                <template v-if="lessonLoaded">
                <div class="container">
                    <div class="bg-body" id="moduleContent">


                        <div class="d-flex flex-wrap align-items-end mb-16pt">
                            <h2 class=" flex m-0">{{lessons.title}} </h2>
                        </div>
                        <p class="hero__lead measure-hero-lead  mb-24pt"> {{module[activeModuleIndex[0][0]].title}}</p>
                        <p class="content" v-html="module[activeModuleIndex[0][0]].content"></p>
                    </div>

                </div>
                </template>
                <div class="bg-gradient-primary pb-lg-64pt py-32pt">

                    <template v-if="lessonLoaded">
                        <div class="container">
                            <nav v-if="activeModule && module.length >= 1"  class="course-nav">

                                <a
                                        :disabled="Number(this.$route.params.id) === this.getLessonIds[0]"
                                        v-if="Number(this.activeModuleIndex[0][0]) === 0"
                                        @click="prevLesson"
                                        class="tool" data-tip="Previous module"
                                ><span class="material-icons ">chevron_left</span>
                                    <div style="
                                                top: 37px;
                                                display: inline;
                                                position: absolute;
                                                text-align: center;
                                                color:#fff;

                                            ">
                                        Previous
                                    </div>
                                </a>

                                <a
                                        v-else
                                        :disabled="Number(this.activeModuleIndex[0][1]) === this.moduleIds[0][0]"
                                        @click="prev"
                                        class="tool" data-tip="Previous module"
                                ><span class="material-icons ">chevron_left</span>
                                    <div style="
                                                top: 37px;
                                                display: inline;
                                                position: absolute;
                                                text-align: center;
                                                color:#fff;

                                            ">
                                        Previous
                                    </div>
                                </a>

                                <template v-if="lessons.modules && lessons.modules.length">
                                    <ModuleItem
                                            v-for="module in lessons.modules"
                                            :key="module.id"
                                            :module="module"
                                            :activeId="activeModule"
                                            @click.native="setActiveModule(module.id)"/>
                                </template>

                                <a class="tool" data-tip="Next module"

                                   :disabled="Number(this.$route.params.id) === this.getLessonIds[this.getLessonIds.length - 1]"
                                   v-if="Number(this.activeModuleIndex[0][0]) + 1 === this.moduleIds.length"
                                   @click="nextLesson"
                                >
                                    <span class="material-icons">chevron_right</span>
                                    <div style="
                                                top: 37px;
                                                display: inline;
                                                position: absolute;
                                                text-align: center;
                                                color:#fff;
                                            ">
                                        Next
                                    </div>
                                </a>
                                <a class="tool" data-tip="Next module"

                                   v-else
                                   :disabled="Number(this.activeModuleIndex[0][0]) + 1 >= this.moduleIds.length"
                                   @click="next"
                                >
                                    <span class="material-icons">chevron_right</span>
                                    <div style="
                                                top: 37px;
                                                display: inline;
                                                position: absolute;
                                                text-align: center;
                                                color:#fff;
                                            ">
                                        Next
                                    </div>
                                </a>
                            </nav>
                        </div>
                    </template>
                </div>
<hr />


                <div class="container" id="discussion">

                    <course-discussion :joinedCourse="joinedCourse"/>
                </div>


            </div>

        </template>


    </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {getCourse, getLesson, getLessonModule} from '../../utils/api/course';
  import CourseDiscussion from './CourseDiscussion';
  import setActiveTab from '../../utils/tabPanel';
  import ModuleItem from './ModuleItem';
  import Loader from '../../components/Loader';
  import ModuleQuiz from './ModuleQuiz';

  export default {
    name: 'CourseLesson',
    data(){
      return {

        activeLesson: null,
        componentKey: 0,
        activeLessonIndex: null,


        module: [],
        lessons: [],
        courseData: [],
        moduleData: {},
        loadingLesson: true,
        lessonLoaded: false,
        lessonID: this.$route.params.onlineClassId,
        additionalContent: [],
        moduleIds: [],
        loadingModuleData: false,
        moduleDataLoaded: false,
        modulesListLoaded: false,
        courseLoaded: false,
        joinedCourse: this.$route.params.joinedCourse,
        activeModule: null,
        activeModuleIndex: null,
        reset: false,
        userId: this.$session.get('id')

      };
    },
    created(){
      this.getLesson();
      this.getCourse();

    },

    computed: {
      ...mapGetters([
        'getLessonIds'
      ])
    },
    mounted() {
      this.activeLesson = this.getLessonIds.find((item, index) => {
        return item == this.$route.params.id;
      });
      this.activeLessonIndex = this.getLessonIds.findIndex(item => {
        return item === this.activeLesson;
      });
    },

    methods: {
      next() {
        /**
         * Checks if the index value in activeModuleIndex which maps an index to the module Id is less
         * the module length before incrementing to the next index and fetching the module
         */
        if (Number(this.activeModuleIndex[0][0]) + 1 < this.moduleIds.length) {
          const activeIndex = this.moduleIds.find((item, index) => index === Number(this.activeModuleIndex[0][0]) + 1);
          this.activeModuleIndex = Object.entries(activeIndex);

          this.activeModule = this.activeModuleIndex[0][1];
          return true;
        }
        return false;
      },
      prev() {
        /**
         * Checks if the id value in activeModuleIndex which maps an index to the module Id is same as
         * the first module before decrementing to previous index and fetching the module
         */
        if (Number(this.activeModuleIndex[0][1]) !== this.moduleIds[0]) {
          const activeIndex = this.moduleIds.find((item, index) => index === Number(this.activeModuleIndex[0][0]) - 1);

          this.activeModuleIndex = Object.entries(activeIndex);

          this.activeModule = this.activeModuleIndex[0][1];
          return true;
        }
      },
      nextLesson() {
        const lessonIndex = this.getLessonIds.findIndex((item) => {
          return item === this.activeLesson;
        });
        if (lessonIndex < this.getLessonIds.length) {

          const nextLessonId = this.getLessonIds[lessonIndex + 1];
          if (typeof(nextLessonId) !== "undefined") {

            this.$router.push({ name: 'course-lessons', params: {
              onlineClassId: this.$route.params.onlineClassId,
              id: nextLessonId
            }});

          }

        }

      },
      prevLesson() {
        const lessonIndex = this.getLessonIds.findIndex((item) => {
          return item === this.activeLesson;
        });
        if (lessonIndex !== 0) {
          const prevLessonIndex = this.getLessonIds[lessonIndex - 1];
          this.$router.push({ name: 'course-lessons', params: {
              onlineClassId: this.$route.params.onlineClassId,
              id: prevLessonIndex
            }})
        }
      },
      getLesson() {
        getLesson(this.$route.params.onlineClassId, this.$route.params.id, this.userId)
          .then((response) => {
            if (response.status === 200) {
              this.lessons = response.data.data;
              this.module = response.data.data.modules;
              this.moduleIds = this.module.map((item, index) => {
                return {
                  [index]: item.id
                };
              });

              this.activeModule = this.moduleIds[0][0];
              this.lessonLoaded = true;
              return true;
            }
            this.lessonsLoaded = false;
            return false;
          })
          .catch((error) => {
            this.lessonLoaded = false;
            return error;
          })
          .finally(() => {
            this.loadingLesson = false;
          });
        return true;
      },
      getModule() {
        const { id, onlineClassId } = this.$route.params;
        getLesson(onlineClassId, id, this.userId)
          .then((response) => {
            if (response.status === 200) {
              this.lesson = response.data.data;
              this.lessonLoaded = true;
              return true;
            }
            this.lessonLoaded = false;
            return false;
          }).catch((error) => {
          this.lessonLoaded = false;
          return error;
        }).finally(() => {
          this.loadingLesson = false;
        });
        return true;
      },
      activateTab(ref) {
        return setActiveTab(ref, this.$refs);
      },
      setActiveModule(moduleId) {
        const activeIndex = Object.values(this.moduleIds).find((item, index) => {
          return item[index] === moduleId;
        });
        this.activeModuleIndex = Object.entries(activeIndex);

        this.activeModule = this.activeModuleIndex[0][1];
        this.loadingModuleData = true;
        getLessonModule(this.$route.params.onlineClassId, this.$route.params.id, this.activeModule, this.userId)
          .then((response) => {
            if (response.status === 200) {
              this.moduleData = response.data.data;
              this.additionalContent = response.data.data.additionalContent;
              this.moduleDataLoaded = true;
              return true;
            }
            this.moduleDataLoaded = false;
            return false;
          }).catch((error) => {
          this.moduleDataLoaded = false;
          return error;
        }).finally(() => {
          this.loadingModuleData = false;
        });
      },
      getCourse(){
        getCourse(this.$route.params.onlineClassId, this.userId)
          .then((response) => {
            if (response.status === 200) {
              this.courseData = response.data.data;
              this.courseLoaded = true;
              return true;
            }
            this.courseLoaded = false;
            return false;
          }).catch((error) => {
          this.courseLoaded = false;
          return error;
        }).finally(() => {
          this.loadingCourse = false;
        });
      }
    },
    watch: {
      activeModule(val) {
        this.setActiveModule(this.activeModule);
      },
      // eslint-disable-next-line
      '$route' (from, to) {
        this.lessonLoaded = false;
        this.getLesson();
      },
      loadingModuleData(val) {
        this.activeLesson = this.getLessonIds.find((item, index) => {
          return item == this.$route.params.id;
        });
        this.activeLessonIndex = this.getLessonIds.findIndex(item => {
          return item === this.activeLesson;
        });
      }
    },
    components: {
      CourseDiscussion,
      ModuleItem,
      Loader,
      ModuleQuiz
    }
  };
</script>

<style lang="scss" scoped>
    .thread__aside {
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e0e0e0;
        padding: 0;
    }

    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        &--sm {
            height: 50vh;
        }
    }

    .module {
        &__wrapper {
            padding-top: 0px !important;
        }
        &__body {
            margin-left: 20px;
            .content {
                margin-top: 20px
            }
        }
        &__meta {
            display: flex;
            justify-content: space-between;
            padding: 20px;
            .btn {
                background: $green;
                text-transform: capitalize;
                &:disabled {
                    background: $grey-light;
                    cursor: not-allowed;
                }
            }
        }
    }
</style>

